import { FormOutline } from "./FormOutline";
import { LanguagePicker } from "./LanguagePicker";
import { TextLine } from "features/common/TextLine";
import { SidePanelTextLine } from "features/common/SidePanelTextLine";

import { selectFormType } from "features/qualityForm/qualityFormSlices/qualityFormCommons";
import FormType from "enums/FormType";
import FeatureToggle from "enums/FeatureToggle";
import { useAppSelector } from "app/hooks";
import { selectFeatureToggle } from "features/featureToggles/featureToggleSlice";

import { AssistanceSummary } from "./AssistanceSummary";
import { EvaluationAssistanceSummary } from "./EvaluationAssistanceSummary";
import { AiScoringSummary } from "./AiScoringSummary";

import "./Content.less";

export function Content() {
    const formType = useAppSelector(selectFormType);
    const isAiScoringFTEnabled = useAppSelector((state) => {
        return selectFeatureToggle(state, FeatureToggle.AI_SCORING);
    });

    return (
        <div className="ContentPanel">
            {formType === FormType.SURVEY && (
                <>
                    <LanguagePicker />
                    <TextLine />
                </>
            )}
            {formType === FormType.EVALUATION &&
                (isAiScoringFTEnabled ? (
                    <>
                        <AiScoringSummary />
                        <SidePanelTextLine />
                        <EvaluationAssistanceSummary />
                        <SidePanelTextLine />
                    </>
                ) : (
                    <>
                        <AssistanceSummary />
                        <TextLine />
                    </>
                ))}
            <FormOutline />
        </div>
    );
}
